<app-select-control-with-readonly
    (openedChange)="emit_openedChange($event)"
    (valueChange)="emit_valueChange($event)"
    [classHeight]="input_classHeight$$()"
    [compareWith]="compareWith"
    [control]="control"
    [disabled]="input_disabled$$()"
    [fieldNameValue]="fieldName_value"
    [list]="input_list$$()"
    [readonly]="readonly$$()"
    [subscriptSizing]="'dynamic'"
    [value]="control_displayValue"
 />
